<template>
  <el-dialog
    width="830px"
    modal-append-to-body
    append-to-body
    custom-class="dialog_box"
    :title="edit ? '编辑日志' : '新建日志'"
    :visible.sync="visible"
    :before-close="beforeClose"
    :close-on-click-modal="false"
  >
    <el-form
      ref="editForm"
      :model="formData"
      :rules="formRules"
      size="small"
      label-suffix=":"
      label-width="80px"
    >
      <!-- <el-form-item label="选择产品" prop="name">
        <el-select
          class="form_select"
          v-model="formData.name"
          clearable
          filterable
          placeholder="请选择所属产品"
        >
          <el-option
            v-for="(item, i) in productList"
            :key="i"
            :label="item.companyname"
            :value="item.companyname"
            filterable
          >
          </el-option>
        </el-select>
      </el-form-item> -->

      <el-form-item label="版本号" prop="version">
        <el-input
          class="form_select"
          placeholder="请输入版本号文本,仅支持英文"
          v-model="formData.version"
          clearable
        >
        </el-input>
      </el-form-item>

      <el-form-item label="发布时间" prop="releaseTime">
        <el-date-picker
          class="form_select"
          type="date"
          v-model="formData.releaseTime"
        ></el-date-picker>
      </el-form-item>

      <el-form-item label="更新内容" prop="content">
        <el-input
          type="textarea"
          v-model="formData.content"
          placeholder="请输入文本"
          :rows="6"
          maxlength="200"
          show-word-limit
        ></el-input>
      </el-form-item>

      <el-form-item label="公开状态" prop="status">
        <el-switch
          v-model="formData.status"
          active-color="#13ce66"
          inactive-color="#e3e3e3"
          :active-value="1"
          :inactive-value="0"
        >
        </el-switch>
      </el-form-item>
    </el-form>

    <div class="form_footer">
      <el-button size="small" @click="beforeClose">取消</el-button>
      <el-button
        size="small"
        type="primary"
        @click="submit"
        :loading="btnLoading"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import formRules from "./editRules";
import moment from "moment";
import { pick } from "lodash";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    edit: {
      type: Boolean,
      defalut: false
    },
    initFormData: {
      type: Object,
      default: () => ({})
    },
    productList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      formData: {
        name: "蓝鹰舆情",
        releaseTime: moment().format("YYYY-MM-DD"),
        content: "",
        status: 1,
        version: ""
      },
      btnLoading: false,
      formRules: formRules
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.initData();
      }
    }
  },
  methods: {
    initData() {
      if (this.edit) {
        const pickerData = pick(this.initFormData, [
          "id",
          "content",
          "status",
          "version"
        ]);
        this.formData = Object.assign({}, this.formData, pickerData);
      }
    },
    beforeClose() {
      console.log("触发");
      this.formData = {
        name: "",
        releaseTime: moment().format("YYYY-MM-DD"),
        content: "",
        status: 1,
        version: ""
      };
      this.$emit("close-modal");
      this.$refs.editForm.clearValidate();
    },
    submit() {
      this.$refs.editForm.validate().then(() => {
        this.btnLoading = true;
        const val = { ...this.formData };
        val.releaseTime = moment(val.releaseTime).format("YYYY-MM-DD 00:00:00");
        this.$http({
          url: this.$api.deploy_edit,
          method: "post",
          data: val
        })
          .then(res => {
            if (res.code == 0 && res.data) {
              if (!this.edit) {
                this.$message.success("成功新增日志");
              } else {
                this.$message.success("成功修改日志");
              }
              this.beforeClose();
              this.$emit("update");
              console.log("为什么不调用update方法");
            } else {
              this.$message.error("日志新增或修改失败");
            }
          })
          .catch(err => {
            console.log("表单校验失败", err);
          })
          .finally(() => {
            this.btnLoading = false;
          });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.dialog_box {
  .form_select {
    width: 350px;
  }
  .form_footer {
    padding-top: 20px;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/views/UpdateJournal/Edit.vue